import { H6 } from '@atlassian/mpac-primitives';
import { SiteCompatibleProducts, SiteSelectorSelectSection } from '@atlassian/mpac-site-selection';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SiteSelectorSelect = _ref => {
  let {
    availableSites,
    firstAppCompatibility,
    appInstallConfig,
    hostCloudId,
    isFreeApp
  } = _ref;
  const renderSiteCompatibleProducts = () => {
    return availableSites && /*#__PURE__*/_jsx(SiteCompatibleProducts, {
      mpacBaseUrl: appInstallConfig.mpacBaseUrl,
      selectedSiteCloudId: hostCloudId,
      appCompatibleProduct: firstAppCompatibility,
      changeContainerForTwoClickInstall: true,
      showStripe: true,
      isFreeApp: isFreeApp
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(H6, {
      children: "Select a site"
    }), /*#__PURE__*/_jsx(SiteSelectorSelectSection, {
      availableSites: availableSites,
      firstAppCompatibility: firstAppCompatibility,
      showAppPlans: false,
      changeStylesForTwoClickInstall: true,
      isDisabled: true
    }), renderSiteCompatibleProducts()]
  });
};